import { useState, useMemo, useRef, useEffect } from "react";
import GhostIcon from "./GhostIcon";

export default function GhostSearch({ ghosts, onAnswerSelect, excludedIds, finished, query, setQuery }) {
    const [searchFocused, setSearchFocused] = useState(false);
    const wrapperRef = useRef(null);

    const results = useMemo(() => {
        if (query === "") return []
        return ghosts.filter(
            ghost => ghost.name.toLowerCase().includes(query.toLowerCase()) && !excludedIds.includes(ghost.id)
        )
    }, [query, ghosts, excludedIds])

    function renderResults() {
        return (
            <ul className="ghost-search-results">
                {results.map(ghost => (
                    <li key={ghost.id}
                        onClick={(evt) => onAnswerSelect(ghost.id)}>
                        <img
                            src={ghost.image}
                            alt={`${ghost.name}`}
                            className="ghost-search-results-image"
                        />
                        <span>{ghost.name}</span>
                    </li>
                ))}
            </ul>
        )
    }


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
            setSearchFocused(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
     }, []);
    
    const handleBlur = (e) => {
        if (!wrapperRef.current.contains(e.relatedTarget)) {
            setSearchFocused(false);
        }
    };

    return (
        <div className="ghost-search">
            <div className="gamemode-description-title">
                <GhostIcon classes="gamemode-description-icon"/>
                <h1>Guess the ghost</h1>
            </div>
            <p>Try to guess the ghost! Make your guesses based on results from previous attempts. Matched evidence and hunt thresholds will help you narrow down the correct spirit.</p>
            {finished ? (
                <p>You guessed today's ghost!</p>
             ) : (
                <div className="ghost-search-input-wrapper" ref={wrapperRef}>
                    <input
                        type="text"
                        placeholder="Ghost"
                        value={query}
                        onChange={evt => setQuery(evt.target.value)}
                        onFocus={() => setSearchFocused(true)}
                    />
                    {(results.length > 0 && searchFocused) && renderResults()}
                </div>
            )}
        </div>
    )
}